import LnatLandingPage from './LnatLandingPage';
export default LnatLandingPage;
